import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { $cardBody, $toggleButton } from './style';

const ExpandableText = ({ title, text }) => {
  const TEXT_LIMIT = 140;
  const cleanDescription = text?.trim().replace(/\s+/g, ' ').replace(/\.$/, '') || '';
  const shouldTruncate = cleanDescription.length > TEXT_LIMIT;
  const [expanded, setExpanded] = useState(false);

  const displayedText = expanded || !shouldTruncate ? text : text.slice(0, TEXT_LIMIT).trim() + '...';
  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <div css={$cardBody(expanded)}>
      <span>{title}: </span>
      <span>{displayedText}</span>
      {shouldTruncate && (
        <span
          css={$toggleButton}
          role='button'
          tabIndex={0}
          onClick={toggleExpanded}
          onKeyDown={(e) => e.key === 'Enter' && toggleExpanded()}
        >
          {expanded ? '[Read less]' : '[Read more]'}
        </span>
      )}
    </div>
  );
};

ExpandableText.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ExpandableText;
